// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n-Link {
  text-decoration: none;
  color: var(--color-accent-content-base);
  cursor: pointer;
}
.n-Link:hover {
  text-decoration: none;
  color: var(--color-accent-content-hover);
}
.n-Link.n--disabled {
  color: var(--color-content-disabled);
}
.n-Link--variant-secondary {
  color: var(--color-link-secondary-content-base);
}
.n-Link--variant-secondary:hover {
  color: var(--color-link-secondary-content-hover);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/components/link/Link.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;EACA,wCAAA;AACJ;AAEE;EACE,oCAAA;AAAJ;AAGE;EACE,+CAAA;AADJ;AAGI;EACE,gDAAA;AADN","sourcesContent":[".n-Link {\n  text-decoration: none;\n  color: var(--color-accent-content-base);\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n    color: var(--color-accent-content-hover);\n  }\n\n  &.n--disabled {\n    color: var(--color-content-disabled);\n  }\n\n  &--variant-secondary {\n    color: var(--color-link-secondary-content-base);\n\n    &:hover {\n      color: var(--color-link-secondary-content-hover);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
